import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import authService from '../services/authService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('auth_token'));
  const [loading, setLoading] = useState(true);

  const login = async (credentials) => {
    const response = await authService.login(credentials);

    setUser(response.user);
    setToken(response.token);
    localStorage.setItem('auth_token', response.token);

    return response;
  };

  const logout = async () => {
    try {
      await authService.logout();
    } catch (_) {
      // ignore network errors
    } finally {
      setUser(null);
      setToken(null);
      localStorage.removeItem('auth_token');
    }
  };

  const fetchUser = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const userData = await authService.getUser();
      setUser(userData);
    } catch (error) {
      const status = error?.response?.status;

      // 🔐 logout ONLY if token is truly invalid
      if (status === 401) {
        setUser(null);
        setToken(null);
        localStorage.removeItem('auth_token');
      } else {
        console.warn('fetchUser failed but token kept', status);
      }
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        login,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
